import { keyMirror } from '@tunein/web-utils';

export default keyMirror('pending', 'fulfilled', 'rejected');
